import React, { useEffect, useRef } from 'react';

const styles = {
  cursor: {
    position: 'fixed', width: 12, height: 12,
    background: '#C8440A', borderRadius: '50%',
    pointerEvents: 'none', zIndex: 9999,
    transform: 'translate(-50%, -50%)',
    transition: 'width 0.3s, height 0.3s, background 0.3s',
    mixBlendMode: 'screen',
  },
  ring: {
    position: 'fixed', width: 40, height: 40,
    border: '1px solid rgba(200,68,10,0.4)', borderRadius: '50%',
    pointerEvents: 'none', zIndex: 9998,
    transform: 'translate(-50%, -50%)',
  },
};

export default function Cursor() {
  const cursorRef = useRef(null);
  const ringRef = useRef(null);
  const pos = useRef({ mx: 0, my: 0, rx: 0, ry: 0 });

  useEffect(() => {
    const onMove = e => { pos.current.mx = e.clientX; pos.current.my = e.clientY; };
    document.addEventListener('mousemove', onMove);

    let raf;
    const animate = () => {
      const p = pos.current;
      p.rx += (p.mx - p.rx) * 0.12;
      p.ry += (p.my - p.ry) * 0.12;
      if (cursorRef.current) { cursorRef.current.style.left = p.mx + 'px'; cursorRef.current.style.top = p.my + 'px'; }
      if (ringRef.current) { ringRef.current.style.left = p.rx + 'px'; ringRef.current.style.top = p.ry + 'px'; }
      raf = requestAnimationFrame(animate);
    };
    raf = requestAnimationFrame(animate);

    const addHover = () => {
      document.querySelectorAll('a, button, [data-hover]').forEach(el => {
        el.addEventListener('mouseenter', () => {
          if (cursorRef.current) { cursorRef.current.style.width = '20px'; cursorRef.current.style.height = '20px'; cursorRef.current.style.background = '#D4A843'; }
          if (ringRef.current) { ringRef.current.style.width = '60px'; ringRef.current.style.height = '60px'; }
        });
        el.addEventListener('mouseleave', () => {
          if (cursorRef.current) { cursorRef.current.style.width = '12px'; cursorRef.current.style.height = '12px'; cursorRef.current.style.background = '#C8440A'; }
          if (ringRef.current) { ringRef.current.style.width = '40px'; ringRef.current.style.height = '40px'; }
        });
      });
    };
    setTimeout(addHover, 500);

    return () => { document.removeEventListener('mousemove', onMove); cancelAnimationFrame(raf); };
  }, []);

  return (
    <>
      <div ref={cursorRef} style={styles.cursor} />
      <div ref={ringRef} style={styles.ring} />
    </>
  );
}
